import { AxiosClone } from './../AxiosClone';
import {api_url} from '../Configuration/Config';

//get overview statistics
export async function getStatistics(){
    return await AxiosClone.get(`${api_url}/admin/overview`)
}
